import React from 'react';
import { JobT } from '../../../types/Job';
import { JobObj } from '../NewJob/InitObjectJob';
import { useRouteMatch } from 'react-router'
import { getJobById } from '../../../api/JobApi';
import { getCommunications } from '../../../api/CommunicationApi';
import { Container, Spinner, Tab, Tabs } from 'react-bootstrap';
import JobTab from '../NewJob/JobTab/JobTab';
import { JobMode } from '../NewJob/Job';
import ClientTab from '../NewJob/ClientTab/ClientTab';
import ContactTab from '../NewJob/ContactTab/ContactTab';
import config from '../../../constants/config';
import { AxiosInstance } from '../../../utils/RequestMethods';
import { getMarkers } from '../NewJob/JobUtils';
import ContactDispute from './ContactDispute';
export type IJobDisputeProps = {

}


type JobTabsT = 'job' | 'client' | 'contact' | 'signedAgreements'

const JobDispute: React.FC<IJobDisputeProps> = ({ }) => {
    const match = useRouteMatch()
    const [job, setJob] = React.useState<JobT | null>(JobObj);
    const [communicationsItems, setCommunicationsItems] = React.useState([])
    const [isReady, setIsReady] = React.useState(false);
    const [initParams, setInitParams] = React.useState({
        job_id: null,
        token: null
    });

    const [activeTab, setActiveTab] = React.useState<JobTabsT>("job");
    React.useEffect(() => {
        const params = { ...initParams, ...match?.params }
        setInitParams(params)
        init(params)
    }, []);


    const getJobForDisputeById = async (id: number, token: string): Promise<JobT> => {
        const url = `${config.url.jobs}/${id}/dispute`
        let params = {
            data: { token: token }
        }
        return await AxiosInstance.get(url, params).then((res) => {
            if (res?.data) {
                return res.data
            }
            throw new Error("not found job")
        }).catch((error) => {
            throw error;
        })
    }

    const init = async (params): Promise<void> => {
        if (!params?.job_id || !params?.token) return null
        getJobForDisputeById(params.job_id, params?.token).then(async (data) => {
            setJob(data)
            setIsReady(true)
        }).catch((error) => {
            setIsReady(true)
        })
    }

    const renderTabsBootstrap = () => {
        return (

            <Tabs
                // defaultactiveTab='job'
                defaultActiveKey='job'
                id='JobTabs'
                activeKey={`${activeTab}`}
                onSelect={(key: JobTabsT) => { setActiveTab(key) }}>
                <Tab
                    eventKey='job'
                    title='Job'>
                    <JobTab
                        tabIsActive={activeTab == "job"}
                        jobMode={JobMode.Dispute}
                        coords={{
                            latitude: Number(config.coords.lat),
                            longitude: Number(config.coords.long)
                        }}
                        job={job}

                        markers={getMarkers(job)}
                        propagateDate={(data) => { }}
                        strictJobTypes={[]}
                        updateJob={(key, value) => { }}
                        onChangeUseTruck={(value) => { }}
                        showRentTruck={() => { }}
                    />
                </Tab>
                <Tab
                    eventKey='client'
                    title='Client'>
                    <ClientTab
                        tabIsActive={activeTab == "client"}
                        jobMode={JobMode.Dispute}
                        client={job.client}
                        job={job}
                        updateJob={(key, value) => { }}
                    />
                </Tab>

                <Tab eventKey='contact' title='Communications'>
                    <ContactDispute
                        job={job}
                        token={initParams?.token}
                    />
                </Tab>

                <Tab eventKey='signedAgreements' title='Signed Agreements'>
                    <span>Signed Agreements </span>
                </Tab>
            </Tabs>
        )
    }
    if (!isReady || !job) {
        return (
            <Container className="mt-5 ">
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <span>Loading...</span>
                    <Spinner animation="border" variant="success" />
                </div>
            </Container>
        )
    }

    return (
        <div>
            {renderTabsBootstrap()}
        </div>
    );
}

export default JobDispute